import Vue from 'vue';
import { mapGetters } from 'vuex';
import ToggleSlider from 'src/components/widgets/ToggleSlider.vue';
import Project from 'src/api/project';
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    components: { ToggleSlider },
    data() {
        return {
            fromAnalysis: null,
            toAnalysis: null,
            deleteExistingQueries: false,
            successMessage: null
        };
    },
    computed: {
        ...mapGetters([
            'hasRequestErrors', 'serverErrors', 'validationErrors'
        ])
    },
    methods: {
        doCopy() {
            this.$validator.validateAll().then((valid) => {
                if (valid === false) {
                    return;
                }
                let el = document.querySelector('div.primary.submit.button');
                el.classList.add('loading');
                this.successMessage = null;
                Project.copyQueries(this.fromAnalysis, this.toAnalysis, this.deleteExistingQueries)
                    .then((resp) => {
                    el.classList.remove('loading');
                    if (this.hasRequestErrors === false) {
                        this.successMessage = resp.data.detail;
                    }
                })
                    .catch(() => {
                    el.classList.remove('loading');
                });
            }).catch(() => { });
        }
    }
});
